import React, { Fragment, useState } from 'react';
import T from 'prop-types';

import ExportsViewContext from './ExportsViewContext';
import AdvancedChangesModal from './components/Modals/AdvancedChangesModal';

import { makeReport } from './configs/predefined-reports-by-page';

const initialFormMode = {
  isCreate: true,
  isDuplicate: false,
  isEdit: null,
};

const ExportsViewProvider = ({
  initParams,
  reportParams,
  children,
  formMode = initialFormMode,
  prefetchingEntities,
  onInitialLoad,
  onDataTypeChange,
}) => {
  const [initReportParams, setInitReportParams] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [initialLoad, setInitialLoad] = useState(false);

  const closeModal = () => {
    setInitialLoad(false);
    setModalOpen(false);
  };

  const openModal = (e, localParams = {}) => {
    if (localParams.initialEntitiesLoad) {
      setInitialLoad(localParams.initialEntitiesLoad);
    }
    const initReport = makeReport({
      initParams,
      reportParams: { ...reportParams, ...localParams },
    });
    setInitReportParams(initReport);
    setModalOpen(true);
  };

  return (
    <Fragment>
      <ExportsViewContext.Provider value={{ openAdvancedExportModal: openModal }}>
        {children}
      </ExportsViewContext.Provider>
      {isModalOpen && (
        <AdvancedChangesModal
          open={isModalOpen}
          initParams={initReportParams}
          formMode={formMode}
          prefetchingEntities={prefetchingEntities}
          onInitialLoad={initialLoad ? onInitialLoad : null}
          onDataTypeChange={onDataTypeChange}
          onClose={closeModal}
        />
      )}
    </Fragment>
  );
};

ExportsViewProvider.propTypes = {
  children: T.node.isRequired,
  initParams: T.shape({
    maxDate: T.string,
    maxPeriod: T.oneOfType([T.string, T.number]),
    permissions: T.object,
    pageName: T.string,
  }).isRequired,
  reportParams: T.shape({
    start_date: T.string,
    end_date: T.string,
    name: T.string,
    entities: T.array,
    countries_iso: T.array,
  }).isRequired,
  formMode: T.object,
  prefetchingEntities: T.bool,
  onDataTypeChange: T.func,
  onInitialLoad: T.func,
};

export default ExportsViewProvider;
